import { HttpErrorResponse } from "@angular/common/http";
import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { Subject } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SpinComponent } from "common/spin/spin.component";

@Component({
	selector: "stages-loading-error-embeddable",
	templateUrl: "./stages-loading-error-embeddable.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, SpinComponent, AsyncPipe],
})
export class FilesLoadingErrorEmbeddableComponent {
	readonly credentialsValid = input.required<boolean>();

	readonly loadingError$ = input.required<Subject<HttpErrorResponse>>();
}
